// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"f3e6e660","163":"6dfc47fa","259":"0ea07c34","317":"088511a2","338":"945239ab","425":"d97ae75a","501":"1e18c1c8","637":"bf019ed6","830":"04ac2a49"}[chunkId] + ".chunk.js";
};